/* rk-swatch-pulse (22 Oct 2026, Alexander after the Clarity notes: "a gentle one-time pulse on the swatches when they scroll into view").
   Product pages and the lp-/fn- landing pages (loaded from snippets/bf26z-sitewide.liquid). The first time a colour swatch row is mostly
   on screen, its chips grow 6% and settle, one after another (90ms apart), once per page view. Nothing runs for reduced-motion users.
   Styles: assets/rk-system.css (rk-sw-pulse). Rows: the theme picker (.product-form__input--swatches) and the SoftClip picker (.rk-sc__swatches). */
(function () {
  if (window.rkSwatchPulse) return; window.rkSwatchPulse = 1;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.main-product__info-container .product-form__input--swatches, .main-product__info-container .rk-sc__swatches';
  var CHIP = '.color-swatch__image, .rk-sc__swatch i';
  var done = false;
  function pulse(row) {
    var chips = [].slice.call(row.querySelectorAll(CHIP));
    chips.forEach(function (c, i) { c.style.animationDelay = (i * 90) + 'ms'; });
    row.classList.add('rk-pulse');
    setTimeout(function () { row.classList.remove('rk-pulse'); chips.forEach(function (c) { c.style.animationDelay = ''; }); }, 700 + chips.length * 90);
  }
  function boot() {
    var rows = [].slice.call(document.querySelectorAll(SEL)).filter(function (r) { return r.querySelector(CHIP); });
    if (!rows.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || done) return;
        done = true; io.disconnect(); setTimeout(function () { pulse(e.target); }, 250);
      });
    }, { threshold: 0.9 });
    rows.forEach(function (r) { io.observe(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
